import { Collection } from 'modules/core/lib/mobx-rest'

import Value from 'modules/custom_resources/store/models/customResources/Value'

class Values extends Collection<Value> {
  get cacheKey(): string {
    return 'values'
  }

  model() {
    return Value
  }
}

const singleton: Values = new Values()

export default singleton
